import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import { iterateStringEnum } from "../../../../lib/enums"
import { DeviceType, DisplayTypes } from "../deviceTypes"

type SelectDeviceTypeTypeFilterProps = {
    deviceType: DeviceType
    setDeviceType: (val: DeviceType) => void
    className?: string
}

export function SelectDeviceTypeFilter({ deviceType, setDeviceType, className }: SelectDeviceTypeTypeFilterProps) {
    return (
        <FormControl sx={{ minWidth: "13rem" }}>
            <LocalizedStrict id="device-details-group-table-device-type-filter-label">
                <InputLabel id="devices-table-select-filter">Device Type</InputLabel>
            </LocalizedStrict>
            <LocalizedStrict id="device-details-group-table-device-type-filter-label-label" attrs={{ label: true }}>
                <Select
                    labelId="devices-table-select-filter"
                    id="devices-table-select-filter-on"
                    value={deviceType}
                    label="Device Type"
                    onChange={(e) => setDeviceType(e.target.value as DeviceType)}
                    className={className}
                >
                    {[...iterateStringEnum(DisplayTypes)].map((value) => (
                        <MenuItem key={value} value={value}>
                            <LocalizedEnum base="devices-table-select-filter-on-item" enumValue={value}>
                                <span>{value}</span>
                            </LocalizedEnum>
                        </MenuItem>
                    ))}
                </Select>
            </LocalizedStrict>
        </FormControl>
    )
}
